import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p458696534025859072',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
